import style from "./ServiceNav.module.scss";
import React from "react";

const ServiceNav = ({label, children}: {label: string} & React.PropsWithChildren) => {
    const enhancedChildren = React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                className: style.item,
                key: child.key || `child-${index}`
            });
        }
        return child;
    });
    return <div className={style["main-nav"]}>
        <div className={style["nav"]}>
            <div className={style["label"]}>{label}</div>
            {enhancedChildren}
        </div>
    </div>
}

export default ServiceNav;
export {ServiceNav}